import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export default function Essap() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/essap").then((r) => setD(r.data)).catch(() => setD({ contenu: "" })); }, []);
  return (
    <div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-14 lg:py-20">
        {d === null ? <Loader2 className="h-8 w-8 animate-spin text-emerald-700" /> : d.contenu ? (
          <>
            {d.updated_at && <p className="text-sm text-slate-500">Mis à jour le {fmtDate(d.updated_at)}</p>}
            <div data-testid="essap-content" className="mt-6 rounded-2xl border border-emerald-900/10 bg-white p-6 sm:p-10 text-slate-700 leading-relaxed whitespace-pre-line">{d.contenu}</div>
          </>
        ) : <p data-testid="essap-empty" className="text-slate-500">Les informations sur l'ESSAP seront publiées prochainement.</p>}
      </article>
    </div>
  );
}
